import { render, staticRenderFns } from "./SquareFill.vue?vue&type=template&id=47cf9b72"
import script from "./SquareFill.vue?vue&type=script&lang=js"
export * from "./SquareFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports